import type { AppFeatureFlagsNetworkModel } from '@norlys-a-s/norlys-play-kmm';
import { FeatureFlags } from '@smart-tv/typings/content';

import { kmm } from './kmm';

const responseMapper = (data: AppFeatureFlagsNetworkModel): FeatureFlags => {
  return {
    showMyDetails: Boolean(data.supportsMyDetails),
    showSearch: Boolean(data.supportsSearch),
    showUniverses: Boolean(data.supportsUniverses)
  };
};

export const getAppFeatureFlags = async (): Promise<FeatureFlags> => {
  const appFeatureFlags = await kmm((repo) => repo.getAppFeatureFlags());
  return responseMapper(appFeatureFlags);
};

export default getAppFeatureFlags;
